import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
  selector: 'app-flag',
  standalone: true,
  // eslint-disable-next-line max-len
  styles: [`.flag { border-radius: 2px; display: inline-block; line-height: 0; overflow: hidden; vertical-align: middle; }`],
  template: `<span class="flag" [style.width.px]="size" [style.height.px]="size" [innerHTML]="svg"></span>`
})
export class FlagComponent {
  @Input() public size: number = 18;
  public svg: SafeHtml = '';

  private innerCode: string = '';
  private innerTitle: string = '';

  private static readonly fallback: string = '<rect width="24" height="16" fill="#cbd2da"/>';

  private static readonly flags: { [code: string]: string } = {
    ar: '<rect width="24" height="16" fill="#006C35"/>',
    cn: '<rect width="24" height="16" fill="#DE2910"/><path d="M5 3l1 3-3-2h4l-3 2z" fill="#FFDE00"/>',
    // eslint-disable-next-line max-len
    de: '<rect width="24" height="5.33" fill="#000"/><rect y="5.33" width="24" height="5.33" fill="#D00"/><rect y="10.66" width="24" height="5.34" fill="#FFCE00"/>',
    // eslint-disable-next-line max-len
    en: '<rect width="24" height="16" fill="#B22234"/><rect y="1.23" width="24" height="1.23" fill="#fff"/><rect y="3.69" width="24" height="1.23" fill="#fff"/><rect y="6.15" width="24" height="1.23" fill="#fff"/><rect y="8.62" width="24" height="1.23" fill="#fff"/><rect y="11.08" width="24" height="1.23" fill="#fff"/><rect y="13.54" width="24" height="1.23" fill="#fff"/><rect width="9.6" height="8.62" fill="#3C3B6E"/><g fill="#fff"><circle cx="2.4" cy="2.2" r="0.5"/><circle cx="4.8" cy="2.2" r="0.5"/><circle cx="7.2" cy="2.2" r="0.5"/><circle cx="3.6" cy="4.3" r="0.5"/><circle cx="6" cy="4.3" r="0.5"/><circle cx="2.4" cy="6.4" r="0.5"/><circle cx="4.8" cy="6.4" r="0.5"/><circle cx="7.2" cy="6.4" r="0.5"/></g>',
    es: '<rect width="24" height="16" fill="#c60b1e"/><rect y="4" width="24" height="8" fill="#ffc400"/>',
    // eslint-disable-next-line max-len
    fr: '<rect width="8" height="16" fill="#0055A4"/><rect x="8" width="8" height="16" fill="#fff"/><rect x="16" width="8" height="16" fill="#EF4135"/>',
    // eslint-disable-next-line max-len
    it: '<rect width="8" height="16" fill="#008C45"/><rect x="8" width="8" height="16" fill="#fff"/><rect x="16" width="8" height="16" fill="#CD212A"/>',
    jp: '<rect width="24" height="16" fill="#fff"/><circle cx="12" cy="8" r="4.2" fill="#BC002D"/>',
    // eslint-disable-next-line max-len
    kr: '<rect width="24" height="16" fill="#fff"/><circle cx="12" cy="8" r="3.4" fill="#CD2E3A"/><path d="M8.6 8a3.4 3.4 0 016.8 0z" fill="#0047A0"/>',
    // eslint-disable-next-line max-len
    nl: '<rect width="24" height="5.33" fill="#AE1C28"/><rect y="5.33" width="24" height="5.33" fill="#fff"/><rect y="10.66" width="24" height="5.34" fill="#21468B"/>',
    // eslint-disable-next-line max-len
    pt: '<rect width="24" height="16" fill="#da291c"/><rect width="9.6" height="16" fill="#046a38"/><circle cx="9.6" cy="8" r="2.6" fill="#ffe000"/>'
  };

  public constructor(private sanitizer: DomSanitizer) {}

  @Input() public set code(value: string) {
    this.innerCode = (value || '').toLowerCase();
    this.render();
  }

  public get code(): string {
    return this.innerCode;
  }

  @Input() public set title(value: string) {
    this.innerTitle = value;
    this.render();
  }

  public get title(): string {
    return this.innerTitle;
  }

  private render(): void {
    const body: string = FlagComponent.flags[this.innerCode] ?? FlagComponent.fallback;
    const titleEl: string = this.innerTitle ? `<title>${this.innerTitle}</title>` : '';
    this.svg = this.sanitizer.bypassSecurityTrustHtml(
      // eslint-disable-next-line max-len
      `<svg viewBox="0 0 24 16" xmlns="http://www.w3.org/2000/svg" role="img" width="100%" height="100%">${titleEl}${body}</svg>`
    );
  }
}
